import { Link } from 'react-router-dom';

const ContactCTASection = () => {
  return (
    <section 
      className="py-20 bg-cover bg-center relative"
      style={{
        backgroundImage: `linear-gradient(rgba(14, 27, 42, 0.8), rgba(14, 27, 42, 0.8)), url('https://public.readdy.ai/ai/img_res/aa93f3991f62fd90da7a911307fc3602.jpg')`
      }}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-playfair text-4xl font-bold text-white mb-6">
          Ready to Explore Your Options?
        </h2>
        <p className="text-xl text-gray-200 mb-8 leading-relaxed">
          Every conversation is confidential and handled directly by our founder. 
          No pressure, no obligations, just honest discussion about your business and your future.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button 
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="btn-primary text-lg px-8 py-4"
          >
            Schedule a Confidential Call
          </button>
          <Link to="/contact" className="btn-secondary text-lg px-8 py-4 text-center border-white text-white hover:bg-white hover:text-navy">
            Send Us a Message
          </Link>
        </div>
        <p className="text-sm text-gray-300 mt-6">
          <i className="ri-shield-check-line mr-2"></i>
          All inquiries are completely confidential
        </p>
      </div>
    </section>
  );
};

export default ContactCTASection;